import axios from 'axios';
import { DossierId } from '@/dossier/models/AbstractDossier';
import { UserId } from '@/shared/models/User';
import { parseRestrictedAccessRecords } from '../converters/restrictedAccessRecordConverters';
import RestrictedAccessRecord, { RestrictedAccessRecordId } from '../models/RestrictedAccessRecord';

export default class AuditAccessClient {
  static async getRestrictedAccessRecordsByUser(userId: UserId): Promise<Array<RestrictedAccessRecord>> {
    const response = await axios.get('/api/mobopro/v1/dossiers/restrictedaccess', { params: { outletuserid: userId } });
    return parseRestrictedAccessRecords(response.data);
  }

  static async getRestrictedAccessRecordsByDossier(dossierId: DossierId): Promise<Array<RestrictedAccessRecord>> {
    const response = await axios.get('/api/mobopro/v1/dossiers/restrictedaccess', { params: { dossierid: dossierId } });
    return parseRestrictedAccessRecords(response.data);
  }

  static async saveRestrictedAccessUsers(dossierId: DossierId, userIds: Array<UserId>): Promise<void> {
    await axios.post('/api/mobopro/v1/dossiers/restrictedaccess', {
      grantToOutletUserIds: userIds,
      dossierIds: [dossierId],
    });
  }

  static async removeAccess(id: RestrictedAccessRecordId): Promise<void> {
    await axios.delete(`/api/mobopro/v1/dossiers/restrictedaccess/${id}`);
  }
}